import React from "react";
import { Controller, useForm } from "react-hook-form";
import Input from "../global/Input";
import ValidateError from "../global/ValidateError";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import Button from "../global/Button";
import { toast } from "react-toastify";
import { toastMessage } from "../../utils/utils";
import { useResetPasswordMutation } from "../../lib/redux/services/Api";
import { useLocation, useNavigate } from "react-router-dom";
import EyeClosedIcon from "../../assets/icons/EyeClosedIcon";
import EyeOpenedIcon from "../../assets/icons/EyeOpenedIcon";
type FormInput = {
  new_password: string;
  confirm_password: string;
};
const ForgetPasswordForm = () => {
  const { Auth, inputs, shared }: DictionaryType = useGetDictionary();
  const [resetPassword] = useResetPasswordMutation();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInput>();

  const onSubmit = async (formData: FormInput) => {
    if (formData.new_password !== formData.confirm_password) {
      toast.error(Auth?.password_confirm_message);
      return;
    }
    try {
      const data = await toast.promise(
        resetPassword({
          ...formData,
          email: location.state.email,
        }).unwrap(),
        toastMessage()
      );

      navigate("/auth/login");
    } catch (error) {
      console.error("Login error:", error);
    }
  };
  return (
    <div>
      {" "}
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="space-y-4 md:space-y-6 max-w-[814px] px-5 py-5"
      >
        <div className="mt-6 flex text-start flex-col items-center justify-center gap-6 w-full">
          <div className="w-full">
            <Controller
              name="new_password"
              rules={{ required: true }}
              control={control}
              render={({ field }) => (
                <Input
                  inputProps={{
                    ...field,
                    type: "password",
                  }}
                  label={inputs.new_password}
                  icon={EyeClosedIcon}
                  toggleIcon={EyeOpenedIcon}
                />
              )}
            />
            {errors.new_password && errors.new_password.type === "required" && (
              <ValidateError />
            )}
          </div>
          <div className="w-full">
            <Controller
              name="confirm_password"
              rules={{ required: true }}
              control={control}
              render={({ field }) => (
                <Input
                  inputProps={{
                    ...field,
                    type: "password",
                  }}
                  label={inputs.confirm_password}
                  icon={EyeClosedIcon}
                  toggleIcon={EyeOpenedIcon}
                />
              )}
            />
            {errors.new_password && errors.new_password.type === "required" && (
              <ValidateError />
            )}
          </div>
          <div className="flex flex-row w-full gap-2">
            <Button
              customeStyle="bg-white text-primary dark:text-white border border-primaryRed w-full rounded-full text-sm py-3 font-bold"
              text={shared.cancel}
              width="max-w-[350px] w-full"
              type="button"
              href="/auth/login"
            />
            <Button
              customeStyle="bg-primary text-white w-full rounded-full text-sm py-3 font-bold"
              text={shared.confirm}
              width="max-w-[350px] w-full"
              type="submit"
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default ForgetPasswordForm;
